import { type FC } from "react";
import { SelectBox, type OptionProps } from "@root/shared/components/SelectBox";
import { Icon } from "@root/shared/components/Icon";
import { Button } from "@root/shared/components/Button";
import { colors } from "@root/shared/styles/sprinkles.css";
import {
  type DisplayDisableReason,
  type DisableButtonText,
} from "@clientFrontend/features/scout/components/PremiumScoutMessageArea/type";
import { DisableAiScoutMessageButton } from "./uiParts/DisabledAiScoutMessageButton";
import * as styles from "./styles.css";

type Props = {
  options: OptionProps[];
  selectedValue: string | number;
  handleSelectChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  handleClickOpenModal: () => void;
  disableText: DisableButtonText;
  hasDisableAiScoutMessageReason: boolean;
  displayDisableReason: DisplayDisableReason;
  isShowSupplementModal: boolean;
  handleClickOpenSupplementModal: () => void;
  handleClickCloseSupplementModal: () => void;
};

export const SpTemplateSelectAndAiTrigger: FC<Props> = ({
  options,
  selectedValue,
  handleSelectChange,
  handleClickOpenModal,
  disableText,
  hasDisableAiScoutMessageReason,
  displayDisableReason,
  isShowSupplementModal,
  handleClickOpenSupplementModal,
  handleClickCloseSupplementModal,
}) => {
  const buttonColor = disableText ? colors.GrayScale94 : colors.TextLink;
  return (
    <div className={styles.wrapper}>
      <p className={styles.title}>効率的に入力する</p>
      <div className={styles.contents}>
        <div className={styles.buttonsWrapper}>
          {hasDisableAiScoutMessageReason && disableText === "AIでメッセージを作成できません" && (
            <>
              <DisableAiScoutMessageButton
                disableText={disableText}
                displayDisableReason={displayDisableReason}
                isShowSupplementModal={isShowSupplementModal}
                handleClickOpenSupplementModal={handleClickOpenSupplementModal}
                handleClickCloseSupplementModal={handleClickCloseSupplementModal}
              />
            </>
          )}
          {(!hasDisableAiScoutMessageReason || disableText === "作成済み") && (
            <div className={styles.createButtonWrapper}>
              <Button
                theme={disableText ? "disabled" : "tertiary"}
                onClick={handleClickOpenModal}
                disabled={hasDisableAiScoutMessageReason}
              >
                <Icon name="sparkle" color={buttonColor} />
                <span
                  className={styles.buttonText}
                  style={{
                    color: buttonColor,
                  }}
                >
                  {disableText || "AIでメッセージを作成"}
                </span>
              </Button>
            </div>
          )}
        </div>
        <div className={styles.borderWrapper}>
          <p className={styles.border}>または</p>
        </div>
        <div className={styles.selectBoxWrapper}>
          <SelectBox
            name="form_client_frontend_premium_scout[client_user_scout_message_template_value]"
            value={selectedValue}
            onChange={handleSelectChange}
            selected={!!selectedValue}
            placeholder="テンプレートを選択する"
            options={options}
            className="js-notice-point-select-box-sp" // React外のJS操作が残っているため
          />
        </div>
      </div>
    </div>
  );
};
